﻿import React from 'react';
import {connect} from 'react-redux';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import {withScrollLink} from '../../Utils/scroll';

import definitions from '../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../Style/cssHelpers';

class DynamicFormErrorBox extends React.Component {
    render () {
        const invalidInputs = Object.keys(this.props.formInputs)
            .map(k => this.props.formInputs[k])
            .filter(i => i.active && i.touched && !i.valid);

        if (invalidInputs.length === 0) {
            return null; 
        }

        return (
            <DynamicFormErrorWrapper>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                >
                    <FormErrorBox align={this.props.currentStep === 0 ? 'left' : 'right'}>

                        <strong>Ojoj, något stämmer inte!</strong>
                        <strong>Kontrollera dina uppgifter för följande frågor:</strong>

                        {invalidInputs.map(input =>
                            <FormErrorLink
                                key={`scroll-${input.id}`}
                                to={`#question-${input.id}`}
                                duration={300}
                            >
                                {input.questionText}
                            </FormErrorLink>
                        )}
                    </FormErrorBox>
                </motion.div>
            </DynamicFormErrorWrapper>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({});
const mapStateToProps = (state) => {
    return {
        currentStep: state.pageCurrentStep
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DynamicFormErrorBox);


// styles

const DynamicFormErrorWrapper = styled.div`
    float: right;
    margin-bottom: 80px;
    max-width: 60%;

    ${mediaQuery.medium(`
        float: left; 
        max-width: none; 

        position: relative; 
        margin-bottom: 10px; 
    `)}
`;

const FormErrorBox = styled.div`
    padding: 20px;
    float: right;
    font-size: 16px;

    ${mediaQuery.large(`
        margin: 30px 0 0 0;
    `)}
    ${mediaQuery.medium(`
        margin: 30px 0 80px 0;
        width: 100%; 
    `)}
    ${mediaQuery.small(`
        margin: 25px 0px 0px 0px;
        padding: 15px;
        float: none;
    `)}
    ${mediaQuery.xxsmall(`
        font-size: 13px;
    `)}

    background-color: white;
    color: ${definitions.colors.error};
    border: 2px solid ${definitions.colors.error}; 

    text-align: ${props => props.align ? props.align : 'left'}; 

    strong {
        display: block;
        font-weight: bold; 
    }
`;

const FormErrorLink = withScrollLink(styled.a`
    display: block;
    
    cursor: pointer; 

    color: ${definitions.colors.blueBackground}; 
    text-decoration: none;
    margin-top: 10px;

    &:hover {
        color: ${definitions.colors.blueBackground};
        text-decoration: underline;
    }
`);